export default __webpack_public_path__ + "static/media/flattop-dude-happy.10a65434.png";